import React from "react";
import "../styles/mobile.css";

const MobilePageLayout = ({ children, ctaLabel, onCtaClick, ctaDisabled }) => {
  return (
    <div className="mobile-container">
      <div className="mobile-content">
        <div className="mobile-card">{children}</div>
      </div>

      {ctaLabel && (
        <div className="sticky-cta">
          <button
            className="primary-btn"
            onClick={onCtaClick}
            disabled={ctaDisabled}
            style={{ backgroundColor: ctaDisabled ? "#ccc" : "" }}
          >
            {ctaLabel}
          </button>
        </div>
      )}
    </div>
  );
};

export default MobilePageLayout;
